import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-product-links',
  templateUrl: './product-links.component.html',
  styleUrls: ['./product-links.component.css']
})
export class ProductLinksComponent implements OnInit {
    argType;

    argValue;

    productLinkTypeKeyno;

    public setting?: Setting;

    public itemsListLinks: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
        this.productLinkTypeKeyno = this.stateService.getStateParams()['productlinktype_keyno'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue && !!this.productLinkTypeKeyno) {
            this.setting = (await this.datatask.Post(1827, {
                argtype: this.argType,
                argvalue: this.argValue,
                productlinktype_keyno: this.productLinkTypeKeyno
            }))[0];
        }
    }

    private async loadProductLinks() {
        if (!this.setting) return;

        this.itemsListLinks = await this.datatask.Post(1831, this.setting);
    }

    public onTabChange() {
        this.loadProductLinks();
    }

    private async init() {
        await this.loadSetting();
        this.loadProductLinks();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    argtype: string;
    argvalue: string;
    productlinktype_keyno: string;
    page_heading: string;
    prod_id: string;
    prod_keyno: string;
    bg_productlinks: string;
}
